/* eslint-disable import/prefer-default-export */

import { GenericAdmiralFields } from '../../Data/Components';
import NewsletterMatchType from '../../Data/NewsletterMatchType';

export const getEmailAddress = (components) => {
  const emailComponent = Object.values(components).find(
    (component) =>
      component.component.mappedQuestionId === GenericAdmiralFields.EMAIL
  );
  return emailComponent ? emailComponent.input.value : null;
};

export const getNewsletterContent = ({
  text,
  subheading,
  additionalSettings,
  dynamicNewsletterName,
}) => {
  if (
    additionalSettings.is_dynamic &&
    dynamicNewsletterName &&
    additionalSettings.dynamic_content &&
    additionalSettings.dynamic_content[dynamicNewsletterName]
  ) {
    const dynamicContent =
      additionalSettings.dynamic_content[dynamicNewsletterName];
    return {
      text: dynamicContent.name,
      brand: dynamicNewsletterName,
      ...dynamicContent,
    };
  }
  return {
    text,
    subheading,
    ...additionalSettings,
  };
};

export const getMatchType = (dynamicNewsletterName, isDynamic) => {
  if (isDynamic) {
    return dynamicNewsletterName
      ? NewsletterMatchType.DYNAMIC
      : NewsletterMatchType.FALLBACK;
  }
  return NewsletterMatchType.STATIC;
};
